@if (cardProduct) {
  <div class="product-card__wrapper">
    <div class="product-card">
      <div class="product-card__image">
        <a [sfProductLink]="product">
          @if (cardProduct.image) {
            <img
              ngSrcset="276w, 500w"
              height="276"
              width="276"
              [ngSrc]="cardProduct.image"
              [alt]="cardProduct.title"
              [loaderParams]="{ product: true, fallback: missingProductImageUrl }"
              (error)="cardProduct.image = missingProductImageUrl"
            />
          }
        </a>
      </div>

      <div class="product-card__content">
        <div>
          <a [sfProductLink]="product">
            <h2 class="product-card__title">{{ cardProduct.title }}</h2>
          </a>

          @let bazaarVoiceID = product | extractBazaarvoiceID: 'Product';
          @if (bazaarVoiceID) {
            <div class="product-card__bazaarvoice">
              <app-bazaarvoice [bvProductId]="bazaarVoiceID" [isInline]="true" />
            </div>
          }

          @if (colorMetaproducts.length > 0) {
            <app-color-metaproduct
              class="product-card__color-metaproduct"
              [showColorNameTitle]="false"
              [isProductPage]="false"
              [customClass]="'product-card'"
              [productId]="cardProduct.id"
              [inputColor]="cardProduct.color ?? ''"
              [metaproducts]="colorMetaproducts"
              [colorReferences]="colorReferences"
              (colorChanged)="onColorChange($event)"
            />
          }
        </div>

        <div>
          @if (displaySpecificProductCampaignHighlights && productSpecificCampaign) {
            <div class="product-card__specific-campaign-highlight">
              <app-specific-campaign-highlight [productSpecificCampaign]="productSpecificCampaign" />
            </div>
          } @else if (displayLowestPrice && product.v4ApiResponse.has_lowest_price === '1') {
            <div class="product-card__lowest-price">
              <span class="lowest-price">
                <i class="fal fa-tag"></i>
                <span i18n="@@product.lowestPrice">Lowest price in 30 days</span>
              </span>
            </div>
          }

          <div class="product-card__price-actions">
            <div class="product-card__price price">
              @if (productPrice) {
                <app-product-price
                  [feedId]="productFeeds"
                  [productPriceInfo]="productPrice"
                  [showLabel]="false"
                  [showPercentage]="false"
                  [bundleRecommendedPricesProducts]="product"
                  [showFromPriceText]="showFromPriceText && hasMetaproducts"
                />
              }
            </div>

            <div class="product-card__actions">
              @if (!hasMetaproducts) {
                <app-add-to-cart-template
                  [small]="true"
                  [productId]="product.id"
                  [cartProduct]="transformProductToCartProduct(product!)"
                  [includeQuantitySelector]="false"
                  [productTitle]="product | translateProductField: 'title'"
                  (addToCart)="onAddToCart(cardProduct.id)"
                />
              } @else {
                <button type="button" class="btn btn-primary btn-add btn-sm" (click)="setShowOptions(true)">
                  <span i18n="@@product.addToCart.short">Add</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-card__options-wrapper" [ngClass]="{ show: showOptions }">
      @if (showOptions) {
        <div class="product-card__options" [ngClass]="{ show: showOptions }" @slideUp>
          <div class="options-close" (click)="setShowOptions(false)"></div>
          <div class="options-content">
            <div class="options-header">
              <span i18n="@@product.chooseOption"> Click to choose an option </span>
              <button type="button" class="btn btn-icon" (click)="setShowOptions(false)">
                <span i18n="@@CLOSE" class="sr-only">Close</span>
                <i class="fal fa-times"></i>
              </button>
            </div>
            @if (colorMetaproducts.length > 0) {
              <div class="options-color">
                <app-color-metaproduct
                  [isProductPage]="false"
                  [metaproducts]="colorMetaproducts"
                  [productId]="cardProduct.id"
                  [inputColor]="cardProduct.color ?? ''"
                  [colorReferences]="colorReferences"
                  (colorChanged)="onColorChange($event)"
                />
              </div>
            }
            @if (selectedOptions.length > 0) {
              <div class="options-options">
                <app-options-metaproduct
                  [isProductPage]="false"
                  [productId]="cardProduct.id"
                  [metaproducts]="selectedOptions"
                  [showOptionPrice]="true"
                  [feedId]="productFeeds"
                  (optionChanged)="onOptionChange($event)"
                />
              </div>
            }
            @if (product.id === cardProduct.id) {
              <div class="add-to-cart">
                <button type="button" class="select-your-options__button btn btn-primary" disabled>
                  <span class="select-your-options__button-text" i18n="@@product.selectYourOptions">Select your options</span>
                </button>
              </div>
            } @else {
              <app-add-to-cart-template
                [productId]="cardProduct.id"
                [cartProduct]="transformProductToCartProduct(product!)"
                [includeQuantitySelector]="false"
                [productTitle]="product | translateProductField: 'title'"
                (addToCart)="onAddToCart(cardProduct.id)"
              />
            }
          </div>
        </div>
      }
    </div>
  </div>
}
